import React from 'react';

const Loader = () => {
    return <div className="calendar-loader">
        <div className="calendar-loader__loader-wrapper">
            <div className="calendar-loader__loader"></div>
        </div>
    </div>;
}

export default Loader;


